const getTenantFromSubdomain = () => {
  try {
    const hostname = window.location.hostname;

    // If localhost or 127.0.0.1, use environment variable if available
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return process.env.REACT_APP_TENANT_NAME || null;
    }

    // Else extract the first part of the hostname (tenant name)
    const parts = hostname.split(".");
    return parts.length > 1 ? parts[0] : null;
  } catch (error) {
    return null;
  }
};

export default getTenantFromSubdomain;
